<template>
  <div class="news-title">
    <li :style="{ color: titleStyle }">{{ title }}</li>
    <li :style="{ margin: m0at ? '10px auto' : '' }"></li>
    <li>{{ news }}</li>
  </div>
</template>

<script>
export default {
  name: "news-title",
  props: { title: "", news: "", m0at: false, titleStyle: null },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.news-title {
  @include inheritWH(269px, 100px);
  @include vertical;

  & > li:first-child {
    font-size: 40px;
    color: $menu-active-color;
  }

  & > li:nth-child(2) {
    width: 45px;
    height: 2px;
    margin: 10px 0;
    //border: 2px solid #e1e1e1;
    background-color: #e1e1e1;
  }

  & > li:last-child {
    color: #d2d2d2;
    font-size: 18px;
  }
}
</style>
